import React, { useCallback, useState, useEffect, ReactElement } from 'react';
import { LoadingProgress, Dialog, ScrollBar } from '@framework-controls/core';
import css from './VehSel.module.scss';
import { strings } from 'src/localization';
import VehicleCard from '../VehicleCard/VehicleCard';
import { VehicleRec, UpdateApptVehInp, SpecData, VehData, QuickTimeInp, ROHistoryData, Appointment, DeteremineDeptInp, VehicleStockPhoto, PhotoList, Customer, UpdateApptCustInp, ApptVeh, DepartmentSpec, ApptCust, ApptOps, ascPageviewInput, ascCtaInteractionInput } from 'src/models';
import AddVehicleCard from '../AddVehicleCard/AddVehicleCard';
import { ComponentMapIds } from '../map';
import { IView } from 'Framework';
import { ViewMode, CustMode, Vehicles } from 'src/enums';
import { IServicesState } from 'src/store/states/AdditionalServices/AdditionalServicesSlice';
import { IconRemove } from 'src/content/icons';
import { DepartmentContactInfo } from '../RecordLockError/DepartmentContactInfo/DepartmentContactInfo';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { ascCtaInteraction, ascPageview } from 'src/helpers/EventHelper/EventHelper';
import { sendSdEvent, getProviderId } from 'src/helpers/ShiftDigitalHelper/ShiftDigitalHelper';
import { IAppointmentState } from 'src/store/states';
import classNames from 'classnames';
import SVPButton from '../SVPButtons/SVPButton';

export interface IProps {
    viewMode: ViewMode;
    vehicles: VehicleRec[];
    selectedVehicle: string;
    name?: string;
    specData?: SpecData;
    specProfile: string;
    store: string;
    branch: string;
    additionalServices: IServicesState;
    apptVin?: string;
    apptVeh: ApptVeh;
    inquiryInvoked: boolean;
    showWeOwes?: boolean;
    showOEMRecall?: boolean;
    showPrvRecom?: boolean;
    custMode: CustMode;
    roHistory: ROHistoryData;
    appointment: Appointment;
    specDefaultDept: string;
    vehiclePhoto: VehicleStockPhoto;
    vehPhotoList: PhotoList;
    menusReturnCode: string;
    theme: string;
    colorSensitiveEnabled: boolean;
    waitOnRecall: boolean;
    noAutoRecall: boolean;
    newVehicleMileage: string
    custInfo?: Customer;
    sameFirstNames: boolean;
    multipleCustomers: boolean;
    identityVerified: boolean;
    verifyingIdentity: boolean;
    locale: string,
    viewVehicles: Vehicles;
    previewFlag: string;
    profileNum: string;
    vehErrMsg?: string;
    mainPaneViewOrder: IView[];
    specDeptData?: DepartmentSpec;
    loading: 'idle' | 'pending' | 'succeeded' | 'failed',
    apptCust: ApptCust,
    myGMRewardsLaunched: string | undefined,
    Itype: string | undefined;
    vehiclesBuilt: boolean;
    countryCode: string;
    vehSelReset: boolean;
    settingHistId: boolean;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
    appointmentState: IAppointmentState;
    selectVehicle: (id: string) => void;
    pushToMainPanes: (inputView: IView) => void;
    getVehicles: () => void;
    clearMenusState: () => void;
    getMenus: (value1, value2) => void;
    getAdditionalServices: (profileNum: string, store: string, branch: string) => void;
    getApptOps: (profileNum: string, store: string, branch: string, vehData?: VehData) => void;
    updateApptVehicle: (inp: UpdateApptVehInp) => void;
    changeMileage: (id: string, mileage: number) => void;
    pushToLeftPane: (inputView: IView) => void;
    getQuickTimes: (inp: QuickTimeInp) => void;
    getROHistory: () => void;
    clearROHistory: () => void;
    clearAdditionalServices: () => void;
    determineDept: (inp: DeteremineDeptInp) => void;
    selectRO: (roNum: string) => void;
    addLogEntry: (action: string, screen: string, details: string) => void;
    onAppCustUpdate: (apptCust: UpdateApptCustInp) => void;
    onCustUpdate: (cust: Customer) => void;
    searchCust: (selectedNum: string) => void;
    getExCust: (selectedNum: string) => void;
    checkAuthToken: () => void;
    clearError: () => void;
    getOEMVehicles: () => void;
    createVehicle: (newVehicle: VehicleRec, custID: string, makeCode: string,
        store: string, branch: string, previewFlag: string, isOEM?: string) => void;
    custSearch: (inp: Customer, profileNum: string, store: string, branch: string, searchForSpm?: string,
        landingPageFlag?: string) => void;
    popFromMainPane: (id: string) => void;
    clearVehError: () => void;
    setLoadingStateToIdle: () => void;
    updateApptOps: (inp:ApptOps[]) => void;
    setNoAutoRecall: (value: boolean) => void;
    gmMemberSearch: (inp: string) => void;
    setApptHistId: (value: string) => void;
    setVehSelReset: (reset: boolean) => void;
}

const VehSel = (props: IProps) => {
    const [gettingData, setGettingData] = useState(false);
    const [clearingData, setClearingData] = useState(false);
    const [selectedVehicle, setSelectedVehicle] = useState('');
    const [msgOpenFlag, setMsgOpenFlag] = useState<boolean>(false);
    const [msgBoxMsg, setMsgBoxMsg] = useState('');
    const [msgBoxHeader, setMsgBoxHeader] = useState('');
    const [onLoad, setOnLoad] = useState<boolean>(true);
    const [creatingVin, setCreatingVin] = useState(false);
    const [showAddError, setShowAddError] = useState(false);
    const [createdVin, setCreatedVin] = useState('');
    const [pageViewEvent, setPageViewEvent] = useState(false);
    const [resettingHist, setResettingHist] = useState(false);
    const currentPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId;
    const isVW = props.specData?.vwTrackingFlag === 'Y';

    const isSDAnalyticsEnabled =
        props.specData?.toyotaTrackingFlag === 'Y' ||
        props.specData?.lexusTrackingFlag === 'Y' ||
        props.specData?.mbzTrackingFlag === 'Y' ||
        props.specData?.mazdaCATrackingFlag === 'Y' ||
        props.specData?.vwTrackingFlag === 'Y' ||
        props.specData?.jaguarTrackingFlag === 'Y' ||
        props.specData?.landRoverTrackingFlag === 'Y';

    useEffect(() => {
        const currentPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1];
        if (currentPane.viewId === ComponentMapIds.VehSel) {
            if (isSDAnalyticsEnabled) {
                sendSdEvent('scheduleServiceVehicleShown', {
                    scheduleServiceSessionId: props.sessionId,
                    scheduleServiceProvider: getProviderId(props.specData, props.toyotaMCLaunched,
                        props.toyotaTDMCLaunched, props.lexusMCLaunched, props.lexusTDMCLaunched),
                }, {oncePerSession: isVW});
            }
        }
    }, [props.mainPaneViewOrder, props.sessionId, props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
        props.lexusMCLaunched, props.lexusTDMCLaunched, isSDAnalyticsEnabled, isVW]);

    const closeHandler = () => {
        setShowAddError(false);
        props.clearVehError();
    };

    // If the search returned a single customer, set the id to the first customer returned.
    // Override the id when the customer selects a vehicle.
    const setSingleCustId = useCallback(() => {
        if (!props.multipleCustomers && props.selectedVehicle === '') {
            props.setApptHistId('0');
        }
    }, [props.setApptHistId, props.multipleCustomers, props.selectedVehicle]);

    if (onLoad) {
        if (props.apptVeh.make !== '') {
            const inp: UpdateApptVehInp = {
                vin: '',
                makeCode: '',
                make: '',
                model: '',
                series: '',
                vehYr: '',
                vehColor: '',
                mileage: 0,
                imagePath: '',
            };

            props.updateApptVehicle(inp);
        }
        if (!props.custInfo?.login) {
            setSingleCustId();
        }
        setOnLoad(false);
    }

    useEffect(() => {
        props.getVehicles();
    }, [props.getVehicles]);

    useEffect(() => {
        // If the user has logged in and then returns to the VehSel screen we must reset the log's selected id
        // then after that call returns we must call the getExCust to reset the log's vehicle array
        if (props.vehSelReset && currentPane === ComponentMapIds.VehSel) {
            props.setVehSelReset(false);
            // set state value to prep for logging user back in to sync the log veh array
            setResettingHist(true);
            props.setApptHistId('');
        }
    }, [currentPane, props.vehSelReset, props.setVehSelReset, props.setApptHistId]);

    useEffect(() => {
        if (resettingHist && !props.settingHistId && props.custInfo) {
            setResettingHist(false);
            const tempCust = {...props.custInfo, nameId: ''};
            props.custSearch(tempCust, props.profileNum, props.store, props.branch, 'Y', 'Y');
        }
    }, [resettingHist,
        props.settingHistId,
        props.vehSelReset,
        props.setVehSelReset,
        props.setApptHistId,
        props.custSearch,
        props.custInfo,
        props.profileNum,
        props.store,
        props.branch,
    ]);

    const CloseMsgBox = useCallback((e: any) => {
        if (msgOpenFlag) {
            const ascCtaInteractionInp : ascCtaInteractionInput = {
                pageType: 'itemlist',
                elementText: strings.ROHistory,
                elementColor: '',
                elementOrder: '',
                elementType: 'popup',
                elementSubType: 'nav_button',
                eventAction: 'click',
                eventActionResult: 'close',
                linkUrl: '',
            };
            ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
            setMsgOpenFlag(false);
        }
    }, [props.vehicles, props.selectedVehicle, msgOpenFlag]);

    useEffect(() => {
        if (gettingData && props.additionalServices.allServices.built &&
            props.viewMode === ViewMode.CustAcct && props.roHistory.built && props.menusReturnCode !== '') {
            setGettingData(false);
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'itemlist',
                errorCode: '',
                itemResults: '',
            };
            if (props.custMode === CustMode.ViewHistory && props.roHistory.roHistory.length === 0) {
                setMsgBoxMsg(strings.VehNoRepair);
                setMsgBoxHeader(strings.ROHistory);
                setMsgOpenFlag(true);
                ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);

                return;
            }
            if (props.custMode === CustMode.ViewRecSvcs && props.additionalServices.allServices.recom.length === 0) {
                setMsgBoxMsg(strings.VehNoPrev);
                setMsgBoxHeader(strings.RecommendedServices);
                setMsgOpenFlag(true);
                ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);

                return;
            }
            if (props.custMode === CustMode.CheckMaintContract) {
                const maintMake = props.vehicles[props.selectedVehicle].make.toLowerCase().split(' ')[0];
                const showMaintContract = (props.countryCode === 'US' &&
                    (((props.toyotaMCLaunched || props.toyotaTDMCLaunched) && maintMake === 'toyota') ||
                    ((props.lexusMCLaunched || props.lexusTDMCLaunched) && maintMake === 'lexus')));
                if (!showMaintContract) {
                    setMsgBoxMsg(strings.VehNoMC);
                    setMsgBoxHeader(strings.MaintenanceContracts);
                    setMsgOpenFlag(true);

                    return;
                }
            }
            props.pushToMainPanes({
                viewId: ComponentMapIds.VehLayout,
                component: ComponentMapIds.VehLayout,
            });
        }
        if (props.additionalServices.allServices.built && gettingData &&
            props.viewMode === ViewMode.Appt && props.menusReturnCode !== '') {
            setGettingData(false);
            // Go to the Add Skip Services screen if specs indicates that is a valid screen.
            // Other wise go to the Addtional Services screen if there is data to display there
            // Other wise go to the ServiceTab
            if (props.specData?.skipServicesFlag) {
                props.pushToMainPanes({
                    viewId: ComponentMapIds.AddVehicle,
                    component: ComponentMapIds.AddVehicle,
                });
            } else {
                let nextViewId = ComponentMapIds.AdditionalServices;
                let nextComponent = ComponentMapIds.AdditionalServices;
                const maintMake = props.selectedVehicle && props.selectedVehicle !== 'AddVehicle' ?
                    props.vehicles[props.selectedVehicle].make.toLowerCase().split(' ')[0]:'';
                const maintContractView = (props.selectedVehicle && props.countryCode === 'US' &&
                    (((props.lexusMCLaunched || props.lexusTDMCLaunched) && maintMake==='lexus') ||
                    ((props.toyotaMCLaunched || props.toyotaTDMCLaunched) && maintMake==='toyota')));
                if (!props.apptVin || (!props.showWeOwes && !props.showPrvRecom && (!props.showOEMRecall ||
                    !props.inquiryInvoked) && !maintContractView)) {
                    nextViewId = ComponentMapIds.ServiceTab;
                    nextComponent = ComponentMapIds.ServiceTab;
                }
                if ((!props.additionalServices.allServices.weOwes[0] && !props.additionalServices.allServices.recom[0] &&
                    !props.additionalServices.allServices.inquiryInvoked && !maintContractView) || props.apptVeh.mileage >= 0) {
                    nextViewId = ComponentMapIds.AddVehicle;
                    nextComponent = ComponentMapIds.AddVehicle;
                }
                props.pushToMainPanes({
                    viewId: nextViewId,
                    component: nextComponent,
                });
            }
        }
        if (gettingData && props.additionalServices.allServices.built &&
            props.viewMode === ViewMode.EditAppt && props.menusReturnCode !== '') {
            setGettingData(false);
            props.pushToMainPanes({
                viewId: ComponentMapIds.Summary,
                component: ComponentMapIds.Summary,
            });
        }
    }, [props.additionalServices, props.viewMode, props.apptVin, props.showWeOwes, props.showPrvRecom, props.showOEMRecall,
        props.inquiryInvoked, props.pushToMainPanes, props.specData, gettingData, props.roHistory, props.custMode,
        props.menusReturnCode, props.selectedVehicle, props.toyotaMCLaunched, props.lexusMCLaunched, props.vehicles,
        selectedVehicle, props.countryCode, props.apptVeh.mileage, props.lexusTDMCLaunched, props.toyotaTDMCLaunched]);

    const footerHandler = useCallback((selectedVehicle: string) => {
        if ((props.custInfo?.nameId || selectedVehicle) && !props.custInfo?.errMsg && !props.identityVerified) {
            props.checkAuthToken();
        }
        if (selectedVehicle === 'AddVehicle') {
            const inp: UpdateApptVehInp = {
                vin: '',
                makeCode: '',
                make: '',
                model: '',
                series: '',
                vehYr: '',
                vehColor: '',
                mileage: 0,
                imagePath: '',
            };

            props.updateApptVehicle(inp);

            switch (props.viewMode) {
                case ViewMode.CustAcct:
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.AddCustVehicle,
                        component: ComponentMapIds.AddCustVehicle,
                    });
                    break;
                case ViewMode.Appt:
                case ViewMode.EditAppt:
                default:
                    if (props.custInfo && props.custInfo.addVehNameId && (props.custInfo?.nameId === '' ||
                        props.custInfo.nameId === undefined || props.custInfo.nameId !== props.custInfo?.addVehNameId) &&
                        !props.multipleCustomers) {
                        const apptCustInp: Customer = {
                            nameId: '',
                            firstName: props.custInfo.firstName,
                            lastName: props.custInfo.lastName,
                            emailAddress: props.custInfo.emailAddress,
                            phoneNumber: props.custInfo.phoneNumber,
                            login: props.custInfo.login,
                            prefContact: props.custInfo.prefContact,
                            textOptIn: props.custInfo.textOptIn,
                            emailOptIn: props.custInfo.emailOptIn,
                            streetAddress: props.custInfo.streetAddress,
                            stateAddress: props.custInfo.stateAddress,
                            city: props.custInfo.city,
                            zipCode: props.custInfo.zipCode,
                            addVehNameId: props.custInfo.addVehNameId,
                            hasAccount: props.custInfo.hasAccount,
                            vehicleList: props.custInfo.vehicleList,
                            isCompany: props.custInfo.isCompany,
                            phoneType: props.custInfo.phoneType,
                            cellPhone: props.custInfo.cellPhone,
                            retCode: props.custInfo.retCode,
                            gmRedeemAmt: props.custInfo.gmRedeemAmt,
                            encryptFirst: props.custInfo.encryptFirst,
                            encryptLast: props.custInfo.encryptLast,
                            encryptEmail: props.custInfo.encryptEmail,
                            encryptPhone: props.custInfo.encryptPhone,
                            ascCustId: props.custInfo.ascCustId,
                        };
                        props.onAppCustUpdate(apptCustInp);
                        props.onCustUpdate(apptCustInp);
                    }
                    if (props.viewMode === ViewMode.Appt && props.myGMRewardsLaunched === 'Y') {
                        props.gmMemberSearch(props.apptCust.custEmailAddress);
                    }
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.AddVehicle,
                        component: ComponentMapIds.AddVehicle,
                    });
                    props.pushToLeftPane({
                        viewId: ComponentMapIds.PropertyOptions,
                        component: ComponentMapIds.PropertyOptions,
                    });
            }
        } else {
            if (selectedVehicle !== '') {
                let selVeh = {} as VehicleRec;
                const vehicleIndex = props.vehicles.findIndex(veh => veh.id === selectedVehicle);
                selVeh = props.vehicles[vehicleIndex];
                if (props.viewMode === ViewMode.Appt && props.myGMRewardsLaunched === 'Y') {
                    props.gmMemberSearch(props.apptCust.custEmailAddress);
                }
                const inp: UpdateApptVehInp = {
                    vin: selVeh.vin,
                    makeCode: selVeh.makeCode,
                    make: selVeh.make,
                    model: selVeh.model,
                    series: selVeh.style,
                    vehYr: selVeh.year,
                    vehColor: selVeh.color,
                    mileage: selVeh.prevMileage,
                    imagePath: selVeh.imagePath,
                };
                props.updateApptVehicle(inp);

                if (selVeh.isOEM === 'Y' && props.custMode === CustMode.AddVeh) {
                    const newVeh: VehicleRec = {
                        id: selVeh.id,
                        vin: selVeh.vin,
                        makeCode: selVeh.makeCode,
                        make: selVeh.make,
                        model: selVeh.model,
                        year: selVeh.year,
                        color: '',
                        style: '',
                        imagePath: '',
                        prevMileage: 0,
                        prevRoDate: '',
                        nextAppt: '',
                        lastAdv: '',
                        lastAdvName: '',
                        lastAdvImage: '',
                        lastTrans: '',
                        lastTransLit: '',
                        nameId: '',
                    };
                    props.createVehicle(newVeh, selVeh.id, '',
                        props.store, props.branch, props.previewFlag, 'Y');
                    setSelectedVehicle(selectedVehicle);
                    setCreatedVin(selVeh.vin);
                    setCreatingVin(true);
                }

                if (selVeh.isOEM === 'Y' && !props.vehicles.some(veh => veh.isOEM !== 'Y')) {
                    const apptCustInp: UpdateApptCustInp = {
                        nameId: selVeh.nameId,
                        firstName: props.apptCust.custFirstName,
                        lastName: props.apptCust!.custLastName,
                        emailAddress: props.apptCust!.custEmailAddress,
                        phoneNumber: props.apptCust!.custPhoneNumber,
                        phoneType: props.apptCust!.custPhoneType,
                        prefContact: props.apptCust!.custPrefContact,
                    };
                    props.onAppCustUpdate(apptCustInp);
                    props.setApptHistId(selVeh.nameId);
                }

                if (!props.custInfo?.login && (selVeh.isOEM !== 'Y' ||
                    (selVeh.isOEM === 'Y' && props.vehicles.some(veh => veh.isOEM !== 'Y')))) {
                    // This Search will set correct id in the log
                    props.searchCust(selectedVehicle);
                    props.getExCust(selectedVehicle);
                } else if (props.custInfo && selVeh.nameId && selVeh.isOEM !== 'Y' &&
                    (props.custInfo?.nameId === '' || props.custInfo.nameId === undefined ||
                    props.custInfo.nameId !== selVeh.nameId)) {
                    // keep current values from the customer state
                    const apptCustInp: Customer = {
                        nameId: selVeh.nameId,
                        firstName: props.custInfo.firstName,
                        lastName: props.custInfo.lastName,
                        emailAddress: props.custInfo.emailAddress,
                        phoneNumber: props.custInfo.phoneNumber,
                        login: props.custInfo.login,
                        prefContact: props.custInfo.prefContact,
                        textOptIn: props.custInfo.textOptIn,
                        emailOptIn: props.custInfo.emailOptIn,
                        streetAddress: props.custInfo.streetAddress,
                        stateAddress: props.custInfo.stateAddress,
                        city: props.custInfo.city,
                        zipCode: props.custInfo.zipCode,
                        addVehNameId: props.custInfo.addVehNameId,
                        hasAccount: props.custInfo.hasAccount,
                        vehicleList: props.custInfo.vehicleList,
                        isCompany: props.custInfo.isCompany,
                        phoneType: props.custInfo.phoneType,
                        cellPhone: props.custInfo.cellPhone,
                        retCode: props.custInfo.retCode,
                        employeeFlag: props.custInfo.employeeFlag,
                        gmRedeemAmt: props.custInfo.gmRedeemAmt,
                        encryptFirst: props.custInfo.encryptFirst,
                        encryptLast: props.custInfo.encryptLast,
                        encryptEmail: props.custInfo.encryptEmail,
                        encryptPhone: props.custInfo.encryptPhone,
                        ascCustId: props.custInfo.ascCustId,
                    };
                    props.onAppCustUpdate(apptCustInp);
                    props.onCustUpdate(apptCustInp);
                    // Set the log id to the vehicle name id
                    props.setApptHistId(selVeh.nameId);
                }

                if (!(selVeh.isOEM === 'Y' && props.custMode === CustMode.AddVeh)) {
                    const defaultDept = props.specDefaultDept;
                    const determineDept = {
                        defaultDept: defaultDept,
                    };
                    props.determineDept(determineDept);
                    props.clearAdditionalServices();
                    props.clearMenusState();
                    setSelectedVehicle(selectedVehicle);
                    setClearingData(true);
                }
            }
        }
        // clear appt ops when a vehicle is selected.
        props.updateApptOps([]);
        if (props.noAutoRecall === true){
            props.setNoAutoRecall(false);
        }
    }, [props.noAutoRecall, props.setNoAutoRecall, props?.clearAdditionalServices, props?.determineDept, props?.pushToLeftPane,
        props?.pushToMainPanes, props?.specDefaultDept, props?.updateApptVehicle,
        props?.vehicles, props?.viewMode, props.clearMenusState, props.custInfo, props.gmMemberSearch, props.myGMRewardsLaunched,
        props.onAppCustUpdate, props.onCustUpdate, props.searchCust, props.multipleCustomers,
        props.getExCust, props.checkAuthToken, props.identityVerified, props.store, props.branch,
        props.previewFlag, props.createVehicle, props.custMode, props.apptCust, props.updateApptOps, props.setApptHistId]);

    useEffect(() => {
        if (creatingVin && props.vehErrMsg === '1002') {
            setCreatingVin(false);
            setShowAddError(true);
        }
        if (creatingVin && props.vehErrMsg === '') {
            setCreatingVin(false);
            props.clearVehError();
            props.clearROHistory();
            props.getROHistory();
            props.selectRO('-1');
            props.custSearch(props.custInfo!, props.profileNum, props.store, props.branch, 'Y', '');
        }
    }, [creatingVin, props.vehErrMsg, props.custSearch, props.store, props.branch, props.profileNum, props.custInfo,
        props.getROHistory, props.clearROHistory, props.selectRO, props.clearVehError]);

    useEffect(() => {
        if (props.loading === 'succeeded' && props.roHistory.built) {
            const currentViewPanes = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1];

            props.getVehicles();
            const selectedVeh = props.custInfo?.vehicleList?.find(v => {
                let match = false;
                if (v.vin) {
                    match = v.vin === createdVin;
                }

                return match;
            });
            if (selectedVeh) {
                props.selectVehicle(selectedVeh.id);
            }

            props.popFromMainPane(ComponentMapIds.VehLayout);
            props.popFromMainPane(currentViewPanes.viewId);
            props.pushToMainPanes({
                viewId: ComponentMapIds.VehLayout,
                component: ComponentMapIds.VehLayout,
            });

            props.setLoadingStateToIdle();
        }
    }, [props.popFromMainPane, props.pushToMainPanes, props.roHistory, props.mainPaneViewOrder, createdVin,
        props.getVehicles, props.selectVehicle, selectedVehicle, props.loading, props.setLoadingStateToIdle,
        props.custInfo]);

    useEffect(() => {
        if (props.custInfo?.nameId && !props.identityVerified) {
            props.checkAuthToken();
        }
    }, [props.checkAuthToken, props.custInfo?.nameId, props.identityVerified]);

    useEffect(() => {
        if (clearingData && props.menusReturnCode === '' && !props.additionalServices.allServices.built) {
            setClearingData(false);
            setGettingData(true);
            props.getAdditionalServices(props.specProfile, props.store, props.branch);
            props.getApptOps(props.specProfile, props.store, props.branch);
            props.getMenus('', '');

            // Should check if specs allows access to the AddSkip screen, if so go there
            // otherwise we should go to either the AdditionalServices screen or the ServiceTab screen based on if
            // there are services to be displayed in the AdditonalServices screen.
            if (props.viewMode === ViewMode.CustAcct) {
                props.clearROHistory();
                props.getROHistory();
                props.selectRO('-1');
            }
        }
    }, [props?.appointment?.department, props?.branch, props?.clearAdditionalServices, props?.clearROHistory,
        props?.determineDept, props?.getAdditionalServices, props?.getApptOps, props?.getMenus, props?.getQuickTimes,
        props?.getROHistory, props?.pushToLeftPane, props?.pushToMainPanes, props?.selectRO, props?.specDefaultDept,
        props?.specProfile, props?.store, props?.updateApptVehicle, props?.vehicles, props?.viewMode, props.clearMenusState,
        clearingData, selectedVehicle, props.menusReturnCode, props.additionalServices.allServices.built]);


    const clickVehicleHandler = (id: string, e: any) => {
        props.selectVehicle(id);
        footerHandler(id);
        const selectedVehicle = props.vehicles[id];
        const make = selectedVehicle?.make ? selectedVehicle.make + ' ' : '';
        const year = selectedVehicle?.year ? selectedVehicle.year + ' ' : '';
        const model = selectedVehicle?.model ? selectedVehicle.model + ' ' : '';
        const vin = selectedVehicle?.vin ? selectedVehicle.vin + ' ' : '';
        const trim = selectedVehicle?.trim ? selectedVehicle.trim + ' ' : '';
        let elementText = make + ' ' + year + ' ' + model + ' ' + trim + ' ' + vin;
        if (id === 'AddVehicle') {
            elementText = strings.AddNewVehicle;
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'itemlist',
            elementText: elementText,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        if (isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceVehicleStart', {
                scheduleServiceSessionId: props.sessionId,
                scheduleServiceProvider: getProviderId(props.specData, props.toyotaMCLaunched,
                    props.toyotaTDMCLaunched, props.lexusMCLaunched, props.lexusTDMCLaunched),
            });
        }
    };

    const custVinsSet = new Set();

    for (const v of props.vehicles) {
        if (v.isOEM !== 'Y') {
            custVinsSet.add(v.vin);
        }
    }

    const uniqueVehicles = props.vehicles.filter(v => !(v.isOEM === 'Y' && custVinsSet.has(v.vin)));

    let filteredVehicles = [] as VehicleRec[];
    switch (props.viewVehicles) {
        case (Vehicles.OEM):
            filteredVehicles = uniqueVehicles.filter(v => v.isOEM === 'Y');
            break;
        case (Vehicles.NAM):
            filteredVehicles = uniqueVehicles.filter(v => v.isOEM !== 'Y');
            break;
        case (Vehicles.All):
            filteredVehicles = uniqueVehicles;
            break;
        default:
            break;
    }

    const vehicles = filteredVehicles.map((vehicle, index) => (
        <VehicleCard
            key={vehicle.id === '' ? index : vehicle.id}
            vehicle={vehicle}
            clickVehicle={clickVehicleHandler}
            selected={props.selectedVehicle === vehicle.id}
            updateMileageState={props.changeMileage}
            viewMode={props.viewMode}
            theme={props.theme}
            newVehicleMileage={props.newVehicleMileage}
            prevMileage={props?.vehicles[props?.selectedVehicle]?.prevMileage!}
            apptMileage={0}
            cancellingAppointment={false}
            Itype = {props.Itype}
            specData={props.specData}
            sessionId = {props.sessionId}
            lexusMCLaunched = {props.lexusMCLaunched}
            lexusTDMCLaunched = {props.lexusTDMCLaunched}
            toyotaMCLaunched = {props.toyotaMCLaunched}
            toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
            appointment = {props.appointmentState}
        />
    ));

    let VehSelTitle = strings.WeFoundYou;
    if (props.viewMode === ViewMode.CustAcct) {
        switch (props.custMode) {
            case CustMode.ViewHistory:
                VehSelTitle = strings.vehWhichHistory;
                break;
            case CustMode.ViewRecSvcs:
                VehSelTitle = strings.vehWhichRecom;
                break;
            case CustMode.CheckRecalls:
                VehSelTitle = strings.vehWhichRecall;
                break;
            case CustMode.CheckMaintContract:
                VehSelTitle = strings.vehWhichMaintContract;
                break;
            case CustMode.AddVeh:
                VehSelTitle = strings.NationwideVehiclesFound;
                break;
            case CustMode.ViewVeh:
            default:
                VehSelTitle = strings.WhichVeh;
        }
    }

    let bodycss = css.mainDiv;
    if (props.viewMode === ViewMode.CustAcct) {
        bodycss = css.CustAcctMainDiv;
    }

    useEffect(() => {
        let logDetail = 'ApptMode';
        if (props.viewMode === ViewMode.CustAcct) {
            logDetail = 'CustMode';
        }
        props.addLogEntry('Screen Entry', 'Vehicle Select ', logDetail);
    }, [
        props.addLogEntry, props.viewMode,
    ]);

    useEffect(() => {
        if (currentPane === ComponentMapIds.VehSel) {
            setPageViewEvent(true);
        }
    }, [currentPane]);

    useEffect(() => {
        if (props.vehiclesBuilt && !props.selectedVehicle && pageViewEvent) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'itemlist',
                errorCode: '',
                itemResults: props.vehicles.length.toString(),
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
            setPageViewEvent(false);
        }
    }, [props.vehicles, props.selectedVehicle, pageViewEvent, props.vehiclesBuilt]);

    useEffect(() => {
        if (props.custInfo?.errMsg) {
            props.clearError();
        }
    }, [props.custInfo, props.clearError]);

    useEffect(() => {
        if (props.identityVerified && (props.custInfo?.nameId || selectedVehicle) && !props.custInfo?.login) {
            if (!selectedVehicle) {
                // Dont use nameId without approval as input for this function.
                props.getExCust(props.custInfo?.nameId!);
            } else {
                props.getExCust(selectedVehicle);
            }
            // setVehiclesFetch(true);
        }
    }, [props.identityVerified, props.custInfo?.nameId, props.custInfo?.login,
        props.getExCust, selectedVehicle]);

    useEffect(() => {
        if (props.identityVerified && props.custInfo) {
            const apptCustInp = {
                nameId: props.custInfo.nameId,
                firstName: props.custInfo.firstName,
                lastName: props.custInfo.lastName,
                emailAddress: props.custInfo.emailAddress,
                phoneNumber: props.custInfo.phoneNumber,
                prefContact: props.custInfo.prefContact,
            };
            props.onAppCustUpdate(apptCustInp);
        }
    }, [props.custInfo, props.identityVerified, props.onAppCustUpdate]);

    useEffect(() => {
        if (props.identityVerified && !props.verifyingIdentity &&
        props.custInfo?.vehicleList &&
        props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId === ComponentMapIds.VehSel) {
            if (props.custInfo.vehicleList.length > 0) {
                props.getVehicles();
                // setVehiclesFetch(false);
            }
        }
    }, [props.getVehicles,
        props.identityVerified,
        props.custInfo?.vehicleList,
        props.verifyingIdentity,
        props.mainPaneViewOrder,
    ]);

    let header = '';

    if ((props.multipleCustomers && !props.sameFirstNames) || props.name === '' || !props.identityVerified) {
        header = strings.WelcomeBack;
    } else {
        header = props.name + ',';
    }

    let errorDialog: ReactElement | null = null;

    if (showAddError) {
        const headerMsg = strings.VinCreateError;
        let contactInfo: JSX.Element | null = null;

        if (props.specDeptData?.contactPhnNum) {
            contactInfo = (
                <span>
                    {strings.IssuContLit}
                    <DepartmentContactInfo contactPhone={props.specDeptData?.contactPhnNum}
                        extension={props.specDeptData?.contactExt}/>
                </span>
            );
        }
        const customError = (
            <div>
                {strings.VehicleAddErrorSPM}
                {contactInfo}
            </div>
        );
        const primaryMessage = strings.TryAgain;

        errorDialog = (
            <ErrorMessage
                headerMsg={headerMsg}
                primaryBtnMessage={primaryMessage}
                secondaryBtnMessage=''
                primaryHandler={closeHandler}
                secondaryHandler={closeHandler}
                closeHandler={closeHandler}
                customError={customError}
            />
        );
    }
    let loading: any = null;
    if (props.loading === 'pending') {
        loading = null;
    } else if (gettingData && !props.waitOnRecall) {
        loading = <LoadingProgress cssClasses={{ spinner: css.progressColor }} size={100} />;
    }

    const nameClassMap = {
        bmw: css.NameBMW,
        mazda: css.NameMazda,
        genesis: css.NameGenesis,
        lexus: css.NameLexus,
    };

    const nameClass = nameClassMap[props.theme] || css.Name;

    const headerBoxStyles = classNames(
        css.headerbox,
        {
            [css.headerboxMazda]: props.theme === 'mazda',
            [css.headerboxGenesis]: props.theme === 'genesis',
        },
    );

    return (
        <div>
            <ScrollBar scrollVertical>
                <div className={bodycss}>
                    {errorDialog}
                    {loading}
                    <h2 className={nameClass}>{header}</h2>
                    <h3>{VehSelTitle}</h3>
                    <hr />
                    <div className={css.vehicles}>
                        {vehicles}
                        <AddVehicleCard
                            key={'AddVehicle'}
                            selected={props.selectedVehicle === 'AddVehicle'}
                            clickVehicle={clickVehicleHandler}
                            theme={props.theme}
                        />
                    </div >
                </div>
            </ScrollBar>
            <Dialog
                id='VehSelMsg'
                cssClasses={{
                    content: (props.theme==='colorSensitive' || props.colorSensitiveEnabled) ? css.contentCS:css.content,
                    paper: (props.theme==='colorSensitive' || props.colorSensitiveEnabled) ? css.paperCS:css.paper,
                    header: (props.theme==='colorSensitive' || props.colorSensitiveEnabled) ?
                        css.LightBoxHeaderCS : css.LightBoxHeader,
                }}
                isOpen={msgOpenFlag}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={''}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={CloseMsgBox}
                onBackDropClick={CloseMsgBox}
                width='full'
            >
                <div className={headerBoxStyles}>
                    {msgBoxHeader}
                    <div className={css.headerIcon}>
                        <IconRemove id='closeBtn' onClick={CloseMsgBox}/>
                    </div>
                </div>
                <div>{msgBoxMsg}
                    <div className={css.dialogFooter}>
                        <SVPButton
                            id='okay'
                            handler={CloseMsgBox}
                            message={strings.OkLit}
                            noArrow
                            theme={props.theme}
                        />
                    </div>
                </div>
            </Dialog>
        </div>);
};

export default VehSel;
